export default __webpack_public_path__ + "static/media/image6.9d90cefd.jpg";